import {Grid, Stack, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {GeneralInfoBase} from '../../components/formsBase/generalBase';
import {PrivacyContent} from './privacyContent';

/**
 * React functional component representing the Privacy Page.
 * @component
 * @returns {JSX.Element} The rendered PrivacyPage component.
 */
export const PrivacyPage = () => {
  return (
    <GeneralInfoBase>
      <Stack alignItems="center" sx={{ml: 1.3, mr: 3}}>
        <Typography variant="h4" textAlign="center">
          Privacy Policy
        </Typography>
        <Grid container maxWidth={1000} spacing={2} sx={{m: 2}} justifyContent="center">
          <Grid item xs={12} md={11}>
            <PrivacyContent isPage={true} />
          </Grid>
        </Grid>
      </Stack>
    </GeneralInfoBase>
  );
};
